import { observer } from 'mobx-react';
import { USER_PERMISSIONS } from 'src/constants/user';
import { appStore } from 'src/mobx/appStore';
import { localeStore } from 'src/mobx/localesStore';
import { modalStore } from 'src/mobx/modalStore';
import { userStore } from 'src/mobx/userStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import Permission from 'src/view/components/Permission/Permission';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { DELIVERY_REQUEST_STATUS } from 'src/view/screens/DeliveryManagementScreen/screens/DeliveryTrackingScreen/constants/deliveryTracking';
import OrderBlockHeader from 'src/view/screens/OrderScreen/components/OrderBlockHeader/OrderBlockHeader';
import OrderBlockItem from 'src/view/screens/OrderScreen/components/OrderBlockItem/OrderBlockItem';
import { useOrderStoreContext } from '~/view/screens/OrderScreen/context';
import './style.scss';

interface IItem {
  title: string;
  data: string | number | undefined;
}

const assistStatuses = [
  DELIVERY_REQUEST_STATUS.PENDING,
  DELIVERY_REQUEST_STATUS.DSP_ISSUE,
  DELIVERY_REQUEST_STATUS.NOT_SENT,
  DELIVERY_REQUEST_STATUS.NO_STATUS,
  DELIVERY_REQUEST_STATUS.ASSIGNED,
  DELIVERY_REQUEST_STATUS.WAY_TO_STORE,
  DELIVERY_REQUEST_STATUS.NEAR_STORE,
  DELIVERY_REQUEST_STATUS.ARRIVED_AT_STORE,
  DELIVERY_REQUEST_STATUS.WAY_TO_CUSTOMER,
  DELIVERY_REQUEST_STATUS.NEAR_CUSTOMER,
  DELIVERY_REQUEST_STATUS.ARRIVED_AT_CUSTOMER,
  DELIVERY_REQUEST_STATUS.RETURNING,
];

const Item = (item: IItem) => {
  return <OrderBlockItem title={item.title} data={item.data} titleClassName="delivery-info__item-title" dataClassName="delivery-info__item-text" />;
};

const DeliveryInfo = observer(() => {
  const { store: orderStore } = useOrderStoreContext();
  if (!orderStore.order) return null;

  const openDeliveryTrackingModal = () => {
    if (!orderStore.order?.branch) return null;

    modalStore.openDeliveryTrackingModal({
      orderId: orderStore.order.id,
      branchLocation: {
        lat: orderStore.order.branch.lat,
        lng: orderStore.order.branch.lng,
      },
      customerLocation: {
        lat: orderStore.order.latitude,
        lng: orderStore.order.longitude,
      },
    });
  };

  const isAssistVisible = appStore.settings?.on_takergo_assist && assistStatuses.includes(orderStore.order?.takergo?.taker_go_status!);

  if (typeof window.renderAssist === 'function' && isAssistVisible) {
    setTimeout(() => {
      window.renderAssist();
    }, 100);
  }

  return (
    <div className="delivery-info d-flex flex-column">
      <OrderBlockHeader title="delivery_info" />
      <ul className="d-flex flex-column mb-4">
        <Item title="service_provider" data={orderStore.order?.takergo?.dsp_name} />
        <Item title="request_id" data={orderStore.order?.takergo?.reference_id} />
        <Item title="txt_delivery_status_h" data={orderStore.order.takergo?.dsp_status} />
        <Item title="hint_name" data={orderStore.order?.takergo?.driver_name} />
        <Item title="txt_mobile" data={orderStore.order?.takergo?.driver_mobile} />
      </ul>
      <Permission permissions={[USER_PERMISSIONS.ORDERS_DELIVERY[0], USER_PERMISSIONS.ORDERS_MANAGMENT[0]]}>
        {isAssistVisible && <Text type={TEXT.CUSTOM} text="delivery_help_tip" className="family-semibold color-gray2 text-size-14" />}
        <div className="d-flex flex-row gap-15">
          {isAssistVisible && (
            <div
              key={orderStore.order?.takergo?.taker_go_status}
              id="taker-assist"
              data-widget-host="taker-assist"
              data-prop-title="TakerGo"
              data-prop-request-status={orderStore.order?.takergo?.taker_go_status}
              data-prop-request-id={orderStore.order?.takergo?.taken_order_id}
              data-prop-dsp-name={orderStore.order?.takergo?.dsp_name}
              data-prop-organization-token={appStore.settings?.takergo_assist_token}
              data-prop-source="T2_deliverytab"
              data-prop-lang={localeStore.language}
              data-prop-is-dashboard=""
              data-prop-username={userStore.user.name}
            ></div>
          )}
          <Button title={localeStore.t('track_delivery_button')} onClick={openDeliveryTrackingModal} appearance="tertiary" className="mt-2" />
        </div>
      </Permission>
    </div>
  );
});

export default DeliveryInfo;
